import { render, staticRenderFns } from "./Denominaciones.vue?vue&type=template&id=3f7e6331&scoped=true"
import script from "./Denominaciones.vue?vue&type=script&lang=js"
export * from "./Denominaciones.vue?vue&type=script&lang=js"
import style0 from "./Denominaciones.vue?vue&type=style&index=0&id=3f7e6331&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7e6331",
  null
  
)

export default component.exports